(function () {
  'use strict';

  if (window.__oasisFixedReservationFlowInstalled) return;
  window.__oasisFixedReservationFlowInstalled = true;

  var pendingForm = null;
  var activeOverlay = null;
  var returnFocusTo = null;

  window.oasisShowGallerySlide = function (productId, requestedIndex) {
    var gallery = document.getElementById('gallery-' + productId);
    if (!gallery || !gallery.classList.contains('oasis-gallery--international')) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-slide'));
    if (!slides.length) return;

    var newIndex = Number(requestedIndex);
    if (!Number.isFinite(newIndex)) newIndex = 0;
    newIndex = ((Math.round(newIndex) % slides.length) + slides.length) % slides.length;

    slides.forEach(function (slide, index) {
      var isActive = index === newIndex;
      slide.classList.toggle('active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (!isActive) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (typeof video.pause === 'function') video.pause();
        });
      }

      // QC D11: hidden slides keep their YouTube embed URL in data-src. Load the player only
      // when the slide is shown and blank it again when the slide is hidden (stops playback).
      slide.querySelectorAll('iframe[data-src]').forEach(function (frame) {
        var lazySrc = frame.getAttribute('data-src');
        if (!lazySrc) return;
        if (isActive) {
          if (frame.getAttribute('src') !== lazySrc) frame.setAttribute('src', lazySrc);
        } else if (frame.getAttribute('src')) {
          frame.setAttribute('src', '');
        }
      });
    });

    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function (thumbnail, index) {
      var isActive = index === newIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    var counter = gallery.querySelector('[data-gallery-current]');
    if (counter) counter.textContent = String(newIndex + 1);
  };

  window.oasisMoveGallerySlide = function (productId, direction) {
    var gallery = document.getElementById('gallery-' + productId);
    if (!gallery) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-slide'));
    if (slides.length < 2) return;

    var activeSlide = gallery.querySelector('.gallery-slide.active') || slides[0];
    var currentIndex = slides.indexOf(activeSlide);
    if (currentIndex < 0) currentIndex = 0;

    window.oasisShowGallerySlide(productId, currentIndex + Number(direction || 0));
  };

  function getOverlay(form) {
    var productId = form && form.getAttribute('data-product-id');
    if (!productId) return null;
    return document.getElementById('oasis-confirm-overlay-' + productId);
  }

  function getFocusable(overlay) {
    if (!overlay) return [];
    return Array.prototype.slice.call(
      overlay.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function setOpenState(overlay, isOpen) {
    if (!overlay) return;
    overlay.classList.toggle('open', isOpen);
    overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function openModal(form) {
    var overlay = getOverlay(form);
    if (!overlay) return false;

    pendingForm = form;
    activeOverlay = overlay;
    returnFocusTo = document.activeElement;

    var checkbox = overlay.querySelector('[data-oasis-confirm-check]');
    var payButton = overlay.querySelector('[data-oasis-confirm-pay]');
    var terms = overlay.querySelector('.oasis-confirm-terms');

    if (checkbox) checkbox.checked = false;
    if (payButton) payButton.disabled = true;
    if (terms) terms.removeAttribute('open');

    setOpenState(overlay, true);
    document.documentElement.classList.add('oasis-confirm-open');
    document.body.style.overflow = 'hidden';

    window.setTimeout(function () {
      var closeButton = overlay.querySelector('[data-oasis-confirm-close]');
      if (closeButton) closeButton.focus();
      else if (checkbox) checkbox.focus();
    }, 30);

    return true;
  }

  function closeModal(restoreFocus) {
    if (!activeOverlay) return;

    setOpenState(activeOverlay, false);
    document.documentElement.classList.remove('oasis-confirm-open');
    document.body.style.overflow = '';

    var focusTarget = returnFocusTo;
    pendingForm = null;
    activeOverlay = null;
    returnFocusTo = null;

    if (restoreFocus !== false && focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function addTermsAcceptance(form) {
    var input = form.querySelector('input[name="properties[Terms Accepted]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Terms Accepted]';
      form.appendChild(input);
    }
    input.value = 'Accepted ' + new Date().toISOString();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('oasis-fixed-reservation-form')) return;

    if (form.dataset.oasisConfirmed === '1') {
      delete form.dataset.oasisConfirmed;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openModal(form);
  }, true);

  document.addEventListener('change', function (event) {
    if (!activeOverlay || !event.target.matches('[data-oasis-confirm-check]')) return;
    var payButton = activeOverlay.querySelector('[data-oasis-confirm-pay]');
    if (payButton) payButton.disabled = !event.target.checked;
  });

  document.addEventListener('click', function (event) {
    var closeTrigger = event.target.closest('[data-oasis-confirm-close], [data-oasis-confirm-back]');
    if (closeTrigger && closeTrigger.closest('.oasis-confirm-overlay')) {
      event.preventDefault();
      closeModal(true);
      return;
    }

    var payButton = event.target.closest('[data-oasis-confirm-pay]');
    if (payButton && activeOverlay && payButton.closest('.oasis-confirm-overlay') === activeOverlay) {
      var checkbox = activeOverlay.querySelector('[data-oasis-confirm-check]');
      if (!pendingForm || !checkbox || !checkbox.checked) return;

      event.preventDefault();
      addTermsAcceptance(pendingForm);

      var form = pendingForm;
      form.dataset.oasisConfirmed = '1';
      closeModal(false);

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return;
    }

    if (activeOverlay && event.target === activeOverlay) closeModal(true);
  });

  document.addEventListener('keydown', function (event) {
    if (!activeOverlay) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(true);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = getFocusable(activeOverlay);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function initInternationalGalleryVisibility() {
    var galleries = Array.prototype.slice.call(
      document.querySelectorAll('.gallery-carousel.oasis-gallery--international')
    );
    var widgets = Array.prototype.slice.call(document.querySelectorAll('.oasis-float-widget-v2--international'));
    if (!galleries.length || !widgets.length) return;

    var visibleGalleries = new Set();
    var setWidgetState = function () {
      var shouldHide = visibleGalleries.size > 0;
      widgets.forEach(function (widget) {
        widget.classList.toggle('oasis-float-widget-v2--gallery-visible', shouldHide);
        widget.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        if (shouldHide) widget.setAttribute('inert', '');
        else widget.removeAttribute('inert');
      });
    };

    galleries.forEach(function (gallery) {
      var rect = gallery.getBoundingClientRect();
      if (rect.bottom > 80 && rect.top < window.innerHeight - 80) visibleGalleries.add(gallery);
    });
    setWidgetState();

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRect.height >= 80) {
          visibleGalleries.add(entry.target);
        } else {
          visibleGalleries.delete(entry.target);
        }
      });
      setWidgetState();
    }, {
      threshold: [0, 0.1, 0.25]
    });

    galleries.forEach(function (gallery) {
      observer.observe(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInternationalGalleryVisibility, { once: true });
  } else {
    initInternationalGalleryVisibility();
  }
})();
